/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateEmployeeRoleRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {CreateEmployeeRoleResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const createEmployeeRole = (request: CreateEmployeeRoleRequest, options?: CashRequestOptions) => post<CreateEmployeeRoleRequest, CreateEmployeeRoleResponse>("/2.0/cash/create-employee-role", request, {...options, rejectOnError: true })